import { render } from "./submittedforms.vue?vue&type=template&id=eba9a9e6&scoped=true"
import script from "./submittedforms.vue?vue&type=script&lang=js"
export * from "./submittedforms.vue?vue&type=script&lang=js"

import "./submittedforms.vue?vue&type=style&index=0&id=eba9a9e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eba9a9e6"]])

export default __exports__